import type { AppFileResult } from '../../config/iConfig.js';
import type { JsonObject } from '../../app/json/jsonValue.js';

/**
 * Loader capabilities required to transport templates into a client-side merge.
 * This deliberately excludes representation-specific template access and handler state.
 */
export abstract class IClientReplayLoader {
    abstract getAppFile(appSite: string, appView: string): AppFileResult;

    abstract getTemplatesApiResponse(appSite: string, appView: string, contextJson: JsonObject, serverTimeMs: number, includeSearchAppSites?: boolean, maskHtml?: boolean, orderedTemplateNames?: string[] | null): string;
}
